import "chart.js/auto";
import BaseListPage from "../../../base/BaseListPage";
import DiscountDayTimePresenter from "./DiscountDayTimePresenter.js";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter.js";
import Export from "../../../components/Export/index.js";
import printChart from "../../../PrintChart.js";
import Select from "react-select";
import DefaultState from "../../sales-and-transactions/components/DefaultState.js";
import InitialPrompt from "../../../components/InitialPrompt/index.js";
import DiscountByTimeReport from "./components/DiscountTimeByReport.js";
import { exportDiscountTransactionsCSV } from "./utils/discountCsvUtils.js";
import {
  getTimeOfDayDiscountChartData,
  getTimeOfDayDiscountChartOptions,
} from "./utils/timeOfDayChartUtils.js";
import { getTransactionDateRange } from "./utils/dateUtils.js";
import ProgressLoader from "../../../components/ProgressLoader/index.js";

class DiscountDayTimePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new DiscountDayTimePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selectedDate: new Date().toISOString().split("T")[0],
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) =>
      obj.store_code.replace("ANGELSPIZZA_", "")
    );
    return [...new Set(storeCodes)];
  }

  handleDateChange = (event) => {
    const selectedDate = event.target.value;
    this.setState({ selectedDate });
    const range = getTransactionDateRange(selectedDate);
    this.presenter.onChangeDate(range);
  };

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions(transactions) {
    const selectedDate = new Date(this.state.selectedDate);
    selectedDate.setHours(0, 0, 0, 0);

    return transactions
      .filter((obj) => obj.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.tran_date);
        transactionDate.setHours(0, 0, 0, 0);

        const selectedDateMatch =
          transactionDate.getTime() === selectedDate.getTime();
        const storeCodeMatch = this.state.selectedStoreCode
          ? transaction.store_code.replace("ANGELSPIZZA_", "") ===
            this.state.selectedStoreCode
          : true;

        return selectedDateMatch && storeCodeMatch;
      });
  }

  countDiscountAmountPerHour = (transactions) => {
    const discountAmounts = new Array(24).fill(0);

    transactions.forEach((transaction) => {
      const hour = new Date(transaction.tran_date).getHours();
      const discountAmount = Number(transaction.discount_amount) || 0;
      discountAmounts[hour] += discountAmount;
    });

    return discountAmounts;
  };

  exportToCSV = () => {
    const { objects } = this.state;
    const filtered = this.filterTransactions(objects);
    exportDiscountTransactionsCSV(filtered);
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }
  render() {
    const { storess, selectedDate } = this.state;
    const filtered = this.filterTransactions(this.state.objects);
    const discountAmountsPerHour = this.countDiscountAmountPerHour(filtered);
    const chartData = getTimeOfDayDiscountChartData(discountAmountsPerHour);
    const chartOptions = getTimeOfDayDiscountChartOptions();
    const chartId = "chart-container18";
    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <h2 className="fw-bold text-capitalize">
            <span style={{ color: "black" }}>Discount</span>
            <span style={{ color: "#83c14a" }}> Value</span>
            <span style={{ color: "black" }}> vs.</span>
            <span style={{ color: "#c5da55" }}> Time of Day</span>
          </h2>
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>

        <div className="row mb-2">
          <div className="col-sm-2">
            <input
              className="form-control"
              type="date"
              onChange={this.handleDateChange}
            />
          </div>
          <div className="col-sm-4">
            <Select
              options={[
                ...this.state.store.map((code) => ({
                  value: code.name,
                  label: code.name,
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              placeholder="Select Store"
              className="basic-single"
              classNamePrefix="select"
            />
          </div>
        </div>
        <ProgressLoader
          loaded={this.state.objects?.length}
          total={this.state.count}
          getProgressPercentage={() => this.getProgressPercentage()}
        />
        {this.state.objects && this.state.objects.length > 0 ? (
          <DiscountByTimeReport
            chartData={chartData}
            chartOptions={chartOptions}
            storess={storess}
            selectedDate={selectedDate}
            chartRef={this.chartRef18}
            containerId="chart-container18"
          />
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(DiscountDayTimePage);
